//@ts-nocheck

import ReactApexChart from "react-apexcharts";
import { Row, Col, Typography } from "antd";
// import eChart from "./configs/eChart";


interface Props {
  categories: Array<any>
  series: Array<any>
}


function EChart(props: Props) {

  const { Title, Paragraph } = Typography;

  // const items = [
  //   {
  //     Title: "3,6K",
  //     user: "Users",
  //   },
  //   {
  //     Title: "2m",
  //     user: "Clicks",
  //   },
  //   {
  //     Title: "$772",
  //     user: "Sales",
  //   },
  //   {
  //     Title: "82",
  //     user: "Items",
  //   },
  // ];

  return (
    <>
      <div id="chart">
        <ReactApexChart
          // className="bar-chart"
          options={{
            chart: {
              type: "bar",
              width: "100%",
              height: "auto",
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 5,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              show: true,
              width: 1,
              colors: ["transparent"],
            },
            grid: {
              show: true,
              borderColor: "#ccc",
              strokeDashArray: 2,
            },
            xaxis: {
              categories: props.categories,
              //  [
              //   "Feb",
              //   "Mar",
              //   "Apr",
              //   "May",
              //   "Jun",
              //   "Jul",
              //   "Aug",
              //   "Sep",
              //   "Oct",
              // ],
              labels: {
                show: true,
                align: "right",
                minWidth: 0,
                maxWidth: 160,
                // style: {
                //   colors: [
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //     "#fff",
                //   ],
                // },
              },
            },
            yaxis: {
              labels: {
                show: true,
                align: "right",
                minWidth: 0,
                maxWidth: 160,
                formatter: (value: number) => Number(+value).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }), // Format numbers with commas
                // style: {
                //   colors: [
                //     "black",
                //     "black",
                //     "black",
                //     "black",
                //     "black",
                //     "black",
                //     "black",
                //     "black",
                //     "black",
                //     "black",
                //   ],
                // },
              },
            },

            tooltip: {
              y: {
                formatter: function (val: any) {
                  return `${Number(val).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })} THB` // Format tooltips with commas
                },
              },
            },
          }}
          series={
            props.series
            //   [
            //   {
            //     name: "Sales",
            //     data: [450, 200, 100, 220, 500, 100, 400, 230, 500],
            //     color: "#fff",
            //   },
            // ]
          }
          type="bar"
          height={220}
        />
      </div>
      {/* <div className="chart-vistior">
        <Title level={5}>Active Users</Title>
        <Paragraph className="lastweek">
          than last week <span className="bnb2">+30%</span>
        </Paragraph>
        <Paragraph className="lastweek">
          We have created multiple options for you to put together and customise
          into pixel perfect pages.
        </Paragraph>
        <Row>
          {items.map((v, index) => (
            <Col xs={6} xl={6} sm={6} md={6} key={index}>
              <div className="chart-visitor-count">
                <Title level={4}>{v.Title}</Title>
                <span>{v.user}</span>
              </div>
            </Col>
          ))}
        </Row>
      </div> */}
    </>
  );
}

export default EChart;
